import { createColumnHelper } from "@tanstack/react-table";

import {
  tableColumns,
  columnHeadersConstants,
  NULL_DATA_HYPHEN,
} from "../../constants";
import {
  compareNumericString,
} from "../../../../shared";

const { SENTIMENT_CHANGE, TRANSACTION_CHANGE } = columnHeadersConstants;
const columnHelper = createColumnHelper();

/**
 * Static column definitions for individual group performance data table.
 */
export const createGroupPerformanceColumns = ({
  cellNameRenderer,
  headerTransactionRatingRenderer,
  headerSurveyCompletionDateRenderer,
  cellTransactionChangeRenderer,
  headerSentimentRatingRenderer,
  cellSentimentChangeRenderer,
}) => [
  columnHelper.accessor("name", {
    header: () => "STORE NAME",
    cell: cellNameRenderer,
  }),
  columnHelper.accessor("recordCount", {
    header: () => "TOTAL RESPONSES",
  }),
  columnHelper.accessor("transactionRating", {
    header: headerTransactionRatingRenderer,
  }),
  columnHelper.accessor("previousTransactionRating", {
    header: headerSurveyCompletionDateRenderer,
    minSize: tableColumns.SIZE_200,
    cell: (row) => row.getValue() || NULL_DATA_HYPHEN,
  }),
  columnHelper.accessor("transactionChange", {
    header: () => TRANSACTION_CHANGE,
    enableSorting: true,
    cell: cellTransactionChangeRenderer,
    sortingFn: compareNumericString,
  }),
  columnHelper.accessor("sentimentRating", {
    header: headerSentimentRatingRenderer,
  }),
  columnHelper.accessor("previousSentimentRating", {
    header: headerSurveyCompletionDateRenderer,
    minSize: tableColumns.SIZE_200,
    cell: (row) => row.getValue() || NULL_DATA_HYPHEN,
  }),
  columnHelper.accessor("sentimentChange", {
    header: () => SENTIMENT_CHANGE,
    enableSorting: true,
    cell: cellSentimentChangeRenderer,
    sortingFn: compareNumericString,
  }),
];
